var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4573 3.22121C25.1575 2.09305 24.2768 1.20766 23.1582 0.90777C21.1304 0.360352 13 0.360352 13 0.360352C13 0.360352 4.86965 0.360352 2.84182 0.90777C1.72318 1.20766 0.842549 2.09305 0.542658 3.22121C0 5.26332 0 9.5189 0 9.5189C0 9.5189 0 13.7745 0.542658 15.8166C0.842549 16.9448 1.72318 17.7921 2.84182 18.092C4.86965 18.6394 13 18.6394 13 18.6394C13 18.6394 21.1304 18.6394 23.1582 18.092C24.2768 17.7921 25.1575 16.94 25.4573 15.8166C26 13.7745 26 9.5189 26 9.5189C26 9.5189 26 5.26332 25.4573 3.22121ZM10.3438 13.3842V5.65365L17.1366 9.5189L10.3438 13.3842Z",
    fill: "#FF3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.3cbe05391d803f1f338cff666d510192.svg";
export { ForwardRef as ReactComponent };